import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    Typography
} from "@material-ui/core";
import API from "../../actions";

const useStyles = makeStyles({
    table: {
        minWidth: 650
    }
});

export default props => {
    const classes = useStyles();

    return (
        <div style={{ margin: "30px 0 20px 0" }}>
            <Typography variant="h4" gutterBottom>
                Anmodninger
            </Typography>
            <TableContainer component={Paper}>
                <Table className={classes.table} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell> Fornavn </TableCell>
                            <TableCell> Efternavn </TableCell>
                            <TableCell> Mail </TableCell>
                            <TableCell align="right"></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {(props.requests || []).map(row => {
                            return (
                                <TableRow key={row.id}>
                                    <TableCell component="th" scope="row">
                                        {row.nameFirst}
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                        {row.nameLast}
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                        {row.email}
                                    </TableCell>
                                    <TableCell align="right">
                                        <Button
                                            color="primary"
                                            onClick={async () => {
                                                await API.addFriend(row.email, props.therapist);
                                                props.update();
                                            }}>
                                            Acceptér
                                        </Button>
                                        <Button
                                            color="secondary"
                                            onClick={async () => {
                                                await API.deleteRequest(props.therapist, row.id);
                                                props.update();
                                            }}>
                                            Afvis
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
};
